// LanguageSwitcher.js
import React from "react";
import { useLanguage } from "../utils/LanguageContext";

const LanguageSwitcher = () => {
  const { language, handleLanguageChange } = useLanguage();

  const languages = [
    { code: "en", label: "English" },
    { code: "fr", label: "French" },
  ];

  return (
    <div>
      <select
        value={language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="bg-gray-800 dark:bg-slate-100 text-white dark:text-slate-800 dark:border dark:border-slate-200 px-2 py-1 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 transition"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
